import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';

import PropTypes from 'prop-types';
import { format } from 'date-fns';
import {
  Input,
  Button,
  DatePicker,
} from '@pearsontechnology/aero-components';

import workspaceService from 'services/WorkspaceService';
import enhanceWithFeatureFlagSubscription from "hocs/enhanceWithFeatureFlagSubscription";
import { intl } from 'containers/LanguageProvider/IntlGlobalProvider';
import { commandWorkspaceCohortCreate } from 'containers/ConnectionManager/actions';
import Modal, { ModalContent, ModalActions } from 'components/Modal';
import RadioButton, { RadioButtonGroup } from 'components/RadioButton';
import { featureKeys } from 'services/FeatureFlagService';
import { createRandomString } from 'utils/createRandomString';

import { enrollmentTypes } from '../constants';
import messages from './messages';
import {
  FormField,
  FormFieldInline,
  ProductIdMessage,
  LTIOptionContainer,
  LTIKeyMessage,
} from './styles';

class CreateCohortModal extends React.Component {
  constructor(props) {
    super(props);
    this.onStartDateChange = this.onStartDateChange.bind(this);
    this.onEnrollmentTypeChange = this.onEnrollmentTypeChange.bind(this);
    this.onProductIdChange = this.onProductIdChange.bind(this);
    this.onCohortNameChange = this.onCohortNameChange.bind(this);
    this.onCohortCreate = this.onCohortCreate.bind(this);
  }

  state = {
    startDate: new Date(),
    productId: '',
    enrollmentType: enrollmentTypes.OPEN,
    isValid: false,
  };

  onStartDateChange(startDate) {
    this.setState({ startDate });
  }

  onProductIdChange(e) {
    this.setState({
      productId: e.target.value,
    });
  }

  onEnrollmentTypeChange(e) {
    this.setState({
      enrollmentType: e.target.value,
    });
  }

  onCohortNameChange(e) {
    const name = e.target.value;
    this.setState({
      name,
      isValid: name !== '',
    });
  }

  onCohortCreate() {
    const { createCohort } = this.props;
    const { name, startDate, enrollmentType, productId } = this.state;

    const newCohortData = {
      name,
      startDate: `${format(startDate, 'ddd, DD MMM YYYY 00:00:00')} GMT`,
      enrollmentType,
      productId: productId.trim() || null,
    };

    newCohortData.workspaceId = workspaceService.getSelectedWorkspaceId();
    if (enrollmentType === enrollmentTypes.LTI) {
      newCohortData.ltiConsumerCredential = {
        key: createRandomString(24),
        secret: createRandomString(36),
      };
    }
    createCohort(newCohortData);
  }

  render() {
    const { onDismiss, visible, getFeatureFlagValue} = this.props;
    const { showEndDate, startDate, productId, isValid } = this.state;
    const isLTIEnabled = getFeatureFlagValue(featureKeys.WORKSPACE_CLASS_LTI_ENROLLMENT);

    return (
      <Modal
        onDismiss={onDismiss}
        visible={visible}
        icon="duotoneClass"
        title={intl.formatMessage(messages.newCohort)}
      >
        <ModalContent>
          <FormField>
            <Input
              label={intl.formatMessage(messages.cohortName)}
              placeholder={intl.formatMessage(messages.cohortNamePlaceholder)}
              onChange={this.onCohortNameChange}
            />
          </FormField>
          <FormFieldInline columns={showEndDate ? '1fr 20px 1fr' : '1fr 1fr 20px'}>
            <DatePicker
              required
              label={intl.formatMessage(messages.startDate)}
              value={startDate}
              minDate={new Date()}
              minDetail="year"
              onChange={this.onStartDateChange}
            />
          </FormFieldInline>
          <FormField>
            <Input
              value={productId}
              label={intl.formatMessage(messages.productId)}
              placeholder={intl.formatMessage(messages.productIdPlaceholder)}
              onChange={this.onProductIdChange}
            />
            <ProductIdMessage>
              {intl.formatMessage(messages.productIdMessage)}
            </ProductIdMessage>
          </FormField>
          <RadioButtonGroup>
            <RadioButton
              label={intl.formatMessage(messages.open)}
              name="enrollment-type"
              value={enrollmentTypes.OPEN}
              checked={this.state.enrollmentType === enrollmentTypes.OPEN}
              onChange={this.onEnrollmentTypeChange}
            />
            <RadioButton
              label={intl.formatMessage(messages.passport)}
              name="enrollment-type"
              value={enrollmentTypes.PASSPORT}
              checked={this.state.enrollmentType === enrollmentTypes.PASSPORT}
              onChange={this.onEnrollmentTypeChange}
            />
            { isLTIEnabled && (
              <LTIOptionContainer>
                <RadioButton
                  label={intl.formatMessage(messages.lti)}
                  name="enrollment-type"
                  value={enrollmentTypes.LTI}
                  checked={this.state.enrollmentType === enrollmentTypes.LTI}
                  onChange={this.onEnrollmentTypeChange}
                />
                { this.state.enrollmentType === enrollmentTypes.LTI && (
                  <LTIKeyMessage>
                    {intl.formatMessage(messages.ltiFindKeys)}
                  </LTIKeyMessage>
                )}
              </LTIOptionContainer>
            )}
          </RadioButtonGroup>
        </ModalContent>
        <ModalActions>
          <Button primary onClick={this.onCohortCreate} disabled={!isValid}>
            {intl.formatMessage(messages.createCohort)}
          </Button>
        </ModalActions>
      </Modal>
    );
  }
}

CreateCohortModal.propTypes = {
  onDismiss: PropTypes.func,
  createCohort: PropTypes.func,
  visible: PropTypes.bool,
};

const mapDispatchToProps = (dispatch) => ({
  createCohort: (cohort) =>
    dispatch(commandWorkspaceCohortCreate(cohort)),
});

const flagNames = [featureKeys.WORKSPACE_CLASS_LTI_ENROLLMENT];
const withConnect = connect(null, mapDispatchToProps);
export default compose(withConnect)(enhanceWithFeatureFlagSubscription(CreateCohortModal, flagNames));
